import LocalizedStrings from 'react-localization';
import no from '../languages/no';
import de from '../languages/de';
const strings = new LocalizedStrings({
	no: no,
	de: de,
});

export default strings;
